import type { Locale } from "@newfungame/contracts";

export interface LanguageActions {
  /** Игрок выбрал язык (`app/start.ts`). */
  changeLocale(locale: Locale): void;
}

const noop = () => {};

export const defaults: LanguageActions = {
  changeLocale: noop,
};

declare module "../actions" {
  interface WindowActions extends LanguageActions {}
}
